"use client";

import React from "react"; 
import Image from "next/image";

import Total_Experience from "../../../../public/assets/nfts/aggregator-marketplace-development/Total_Experience.webp";
import Investment_Raised_for_Startups from "../../../../public/assets/nfts/aggregator-marketplace-development/Investment_Raised_for_Startups.webp";
import Projects_Completed from "../../../../public/assets/nfts/aggregator-marketplace-development/Projects_Completed.webp";
import Tech_Experts_on_Board from "../../../../public/assets/nfts/aggregator-marketplace-development/Tech_Experts_on_Board.webp";
import Global_Presence from "../../../../public/assets/nfts/aggregator-marketplace-development/Global_Presence.webp";
import Client_Retention from "../../../../public/assets/nfts/aggregator-marketplace-development/Client_Retention.webp";
import AnimatedCount from "./CountUp/AnimatedCount";

export const dynamic = "force-dynamic";

const FactoryServices = () => {
    const counterData = [
        {
            id: 1,
            image: Total_Experience,
            alt: "Total Experience",
            title: "Total Experience",
            preDescNumber: 7,
            description: "Years",
            suffix: "+",
        },
        {
            id: 2,
            image: Investment_Raised_for_Startups,
            alt: "Investment Raised for Startups",
            title: "Investment Raised for Startups",
            preDescNumber: 24,
            description: "Million USD",
            suffix: "+",
        },
        {
            id: 3,
            image: Projects_Completed,
            alt: "Projects Completed",
            title: "Projects Completed",
            preDescNumber: 170,
            description: "",
            suffix: "+",
        },
        {
            id: 4,
            image: Tech_Experts_on_Board,
            alt: "Tech Experts on Board",
            title: "Tech Experts on Board",
            preDescNumber: 150,
            description: "",
            suffix: "+",
        },
        {
            id: 5,
            image: Global_Presence,
            alt: "Global Presence",
            title: "Global Presence",
            preDescNumber: 12,
            description: "Countries",
            suffix: "+",
        },
        {
            id: 6,
            image: Client_Retention,
            alt: "Client Retention",
            title: "Client Retention",
            preDescNumber: 90,
            description: "",
            suffix: "%",
        },
    ];

    const counterList = counterData?.map((item, ind) => {
        return (
            <div key={item?.id || ind} className="text-center">
                <div className="grid place-content-center place-items-center">
                    <Image src={item?.image} alt={item?.alt} />
                </div>
                <h3 className="my-4 font-manrope text-xl font-bold">
                    {item?.title && item?.title}
                </h3>
                <h4 className="font-manrope text-3xl font-bold">
                     
                    <AnimatedCount end={item?.preDescNumber} suffix={item?.suffix} />

                    {item?.description && item?.description}
                </h4>
            </div>
        );
    });

    return (
        <>
            <div className={`mt-40 bg-[#FBE4C1]`}>
                <div className="container mx-auto rounded-[2.25rem] p-14">
                    <h2
                        className={`text-2xl lg:text-3xl leading-snug font-bold font-manrope text-[#410EAD] text-center`}
                    >
                        A Snapshot of Our Success (Stats)
                    </h2>
                    <div className="grid gap-4 mt-10 xl:gap-8 md:grid-cols-2 xl:grid-cols-3 place-items-center">
                        {counterList}
                    </div>
                </div>
            </div>
        </>
    );
};

export default FactoryServices;
